import { useMemo } from 'react';
import type { AnalyticsDataPoint } from '../../components/ChartContainer';
import { aggregateByGranularity } from '../../utils/aggregateByGranularity';

export function useRefunds(
    map: Map<string, { amount: number; refundCount: number }> | undefined,
    granularity: 'daily' | 'weekly' | 'monthly',
    currency: string,
): AnalyticsDataPoint[] {
    return useMemo(() => {
        if (!map) return [];
        const data = Array.from(map.entries())
            .map(([code, { amount, refundCount }]) => ({ code, value: amount, volume: refundCount, currency }))
            .sort((a, b) => new Date(a.code).getTime() - new Date(b.code).getTime());
        return aggregateByGranularity(data, granularity);
    }, [map, currency, granularity]);
}
